import { selectSortMethod, updateSortMethod } from '../menu/filtersSlice'
import { ReactComponent as Sort } from 'assets/sort.svg'
import { useDispatch, useSelector } from 'react-redux'
import DropDownList from 'components/DropDownList'

export const sortOptions = [{
  name: 'default',
  value: ''
}, {
  name: 'cheapest',
  value: 'cheapest'
}, {
  name: 'mostExpensive',
  value: 'most-expensive'
}]

const SortSelect = () => {
  const sortOption = useSelector(selectSortMethod)
  const dispatch = useDispatch()
  return (
    <div className='result__sort'>
      <Sort />
      <DropDownList
        translate
        list={sortOptions}
        selectedValue={sortOption}
        changeValue={option => {
          dispatch(updateSortMethod(option))
        }}
      />
    </div>
  )
}

export default SortSelect